import { Container, Row, Col } from 'styled-bootstrap-grid';
import styled, { isStyledComponent } from 'styled-components';
import { useState, useEffect, useContext } from 'react';
import Header from './Header';
import Background from '../assets/img/stadium.jpg';
import LVHPlaceholder from '../assets/img/lvh_placeholder.png';
import LVHIcon from '../assets/img/lvh.png';
import Email from '../assets/img/email.png';
import Ball from '../assets/img/ball.png';
import Phone from '../assets/img/phone-call.png';
import { useOutletContext } from "react-router-dom";
import {
  Outlet,
  Link,
  useLoaderData,
} from "react-router-dom"
import { useParams } from 'react-router-dom';

function Divisional(props) {
  const urlStates = useOutletContext();
  const [divisional, setDivisional] = useState(useLoaderData());
  
  const DivisionalDesktop = styled.div`
    @media only screen and (max-width: 481px) {
      display: none; 
    }
  `
  const H3Title = styled.h3`
    color: white;
    font-size: 40px;
    margin: 0;
  `
  const Banner = styled.div`
    display: block;
    height: 200px;
    background-position-y: 800px;
  `
  const Title = styled.div`
    height: auto;
    margin: 0 auto;
    display: flex;
    padding: 10px;
    position: relative;
    font-size: 25px;
    font-family: 'Oswald',sans-serif;
    text-align: center;
    width: 30%;
  `
  const Info = styled(Title)`
    display: block;
    width: 575px;
    padding-top: 10%;
  `
  
  const Footer = styled.footer`
    background-color: black;
    height: 220px;
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding-top: 50px;
  `

  const Sedes = styled.div`
    margin: 0 50px 0 50px;
    width: 450px
  `

  const Contacto = styled(Sedes)`
    margin: 0 50px 0 50px;
    width: 250px;
  `

  const UlSedes = styled.ul`
    padding: 0;
  `
  const H3Footer = styled(H3Title)`
    color: #0799d4;
    font-family: 'Oswald', sans-serif;
    font-size: 25px;
  `

  const LiSedes = styled.li`
    color: white;
    font-family: 'Roboto', sans-serif;
    list-style: none;
    margin-bottom: 10px;
  `


  // Tabla de grupos

  const ContainerDivisional = styled.div`
    height: auto;
    margin: 0 auto;
    display: flex;
    padding: 5%;
    position: relative;
    font-size: 25px;
    font-family: 'Oswald',sans-serif;
    text-align: center;
    width: 90%;
  `

  const ContainerGrupos = styled.div`
    height: auto;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0px 30px 30px 30px;
    position: relative;
    font-size: 25px;
    font-family: 'Oswald',sans-serif;
    text-align: center;
    width: 100%;
  `

  const Card = styled.div`
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 50%;
    flex: 40%;
    height: 400px;
    margin-right: 20px;
    margin-bottom: 20px;
    &:hover{
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }
    @media only screen and (min-width: 482px) {
      width: 50%;
      flex: 40%;
    }
    @media only screen and (max-width: 481px) {
      width: 90%;
      flex: 100%;
      -webkit-flex: 100%;
    }
  `
  const TituloGrupo = styled.div`
    height: 50px;
    width: 100%;
    font-weight: 700;
    background-color: black;
    color: white;
    padding: 0;
  `

  const BannerStatsGrupo = styled(TituloGrupo)`
    height: 30px;
    background-color: #525252;
    color: white;
    padding: 0;
  `

  const ColGrupo = styled(Col)`
    padding: 0;
    text-align: left;
    font-size: 15px;
  `

  const ColEquipo = styled(Col)`
    padding: 0;
    text-align: left;
    font-size: 18px;
    margin-bottom: 5px;
    margin-top: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `

  const ColGrupoUnit = styled(ColGrupo)`
    text-align: center;
  `

  const ColEquipoUnit = styled(ColGrupoUnit)`
    margin-top: 5px;
    text-align: center;
  `

  const RowGrupo = styled(Row)`
    padding: 0;
    margin: auto;
    width: 90%;
    font-weight: 500;
  `

  // Tabla de ultimos partidos

  const RowEquipo = styled(RowGrupo)`
    border-bottom: 1px solid #f1f1f1;
  `
  const ContainerGruposMobile = styled(ContainerGrupos)`
    padding-top: 0;
    width: 90%;
  `
  
  const ContainerUltimosPartidos = styled(ContainerGrupos)`
    padding-top: 0;
    width: 90%;
    @media only screen and (max-width: 481px) {
      padding-left: 2%;
    }
  `
  const TablePartido = styled.div`
    display: flex;
    justify-content: center;
  `
  const Partido = styled.div`
    width: 40%;
    display: flex;
    flex-flow: column;
    align-items: center;
  `

  const CardPartido = styled(Card)`
    height: 140px;
    padding: 20px 0px 20px 0px;
    margin-bottom: 30px;
    display: inline-block;
    @media only screen and (min-width: 482px) {
      width: 370px;
    }
    @media only screen and (max-width: 481px) {
      width: 330px;
    }
  `


  const H3TitleUltPartidos = styled(H3Title)`
    color: black;
    font-size: 40px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
  `
  const Resultado = styled.div`
    width: 15%;
    @media only screen and (min-width: 482px) {
      font-size: 21px;
    }
    @media only screen and (max-width: 481px) {
      font-size: 18px;
    }
  `

  const ButtonEquipo = styled.a`
    color: inherit;
    text-decoration: none;
  `

  // Mobile viewport
  const DivisionalMobile = styled.div`
    @media only screen and (min-width: 482px) {
      display: none; 
    }
  `
  const ContainerDivisionalMobile = styled(ContainerDivisional)`
    display: flex;
    flex-flow: column;
  `
  const ContainerUltimosPartidosMobile = styled(ContainerUltimosPartidos)`
    flex-flow: column;
  `
  const SedesMobile = styled(Sedes)`
    margin: 0 10px;
    width: 30%;
  `
  const ContactoMobile = styled(Contacto)`
    margin: 0 10px;
    width: 30%;
  `

  const [cardGrupos, setCardGrupos] = useState();

  const [cardUltimosPartidos, setUltPartidos] = useState();
  
  useEffect(() => {
    setCardGrupos(divisional.grupos.map((grupo) => 
      <Card>
        <TituloGrupo>{grupo.nombre.toUpperCase()}</TituloGrupo>
        <BannerStatsGrupo>
          <RowGrupo>
            <ColGrupo style={{width: "10%"}}>#</ColGrupo>
            <ColGrupo style={{width: "40%"}}>Equipo</ColGrupo>
            <ColGrupoUnit style={{width: "10%"}}>J</ColGrupoUnit>
            <ColGrupoUnit style={{width: "10%"}}>G</ColGrupoUnit>
            <ColGrupoUnit style={{width: "10%"}}>E</ColGrupoUnit>
            <ColGrupoUnit style={{width: "10%"}}>P</ColGrupoUnit>
            <ColGrupoUnit style={{width: "10%"}}>Pts.</ColGrupoUnit>
          </RowGrupo>
        </BannerStatsGrupo>
        <div class="container">
          {grupo.equipos.map((equipo) =>
            <ButtonEquipo href={"/equipo/" + equipo.idEquipo + "/" + divisional.idDivisional}>
              <RowEquipo>
                <ColEquipo style={{width: "10%"}}>{grupo.equipos.indexOf(equipo) + 1}</ColEquipo>
                <ColEquipo style={{width: "40%"}}>
                  {equipo.escudo == null ? <img style={{maxHeight: 15, paddingRight: "10px"}} src={LVHPlaceholder}/> : <img style={{maxHeight: 15, paddingRight: "10px"}} src={'https://lvh-images.camila.uy/' + equipo.escudo}/>}
                  {equipo.nombre}
                </ColEquipo>
                <ColEquipoUnit style={{width: "10%"}}>{equipo.statsDivisional.partidos.partidosJugados}</ColEquipoUnit>
                <ColEquipoUnit style={{width: "10%"}}>{equipo.statsDivisional.partidos.partidosGanados}</ColEquipoUnit>
                <ColEquipoUnit style={{width: "10%"}}>{equipo.statsDivisional.partidos.partidosEmpatados}</ColEquipoUnit>
                <ColEquipoUnit style={{width: "10%"}}>{equipo.statsDivisional.partidos.partidosPerdidos}</ColEquipoUnit>
                <ColEquipoUnit style={{width: "10%"}}>{equipo.statsDivisional.puntos}</ColEquipoUnit>
              </RowEquipo>
            </ButtonEquipo>
          )},
        </div>
      </Card>
    ));

    setUltPartidos(divisional.partidos.slice(0, 4).map((partido) =>
      <ButtonEquipo href={"/partido/" + partido.idPartido + "/divisional/" + divisional.idDivisional}><CardPartido>
        <TablePartido>
          <Partido>
            {partido.equipo1.escudo == null ? <img style={{maxHeight: 60, paddingRight: "10px"}} src={LVHPlaceholder}/> : <img style={{maxHeight: 60, paddingRight: "10px"}} src={'https://lvh-images.camila.uy/' + partido.equipo1.escudo}/>}
            <p>{partido.equipo1.nombre}</p>
          </Partido> 
          <Resultado>
            <p style={{position: "relative", top: "15%"}}>{partido.resultado.golesEquipo1 + " - " + partido.resultado.golesEquipo2}</p>
          </Resultado>
          <Partido>
            {partido.equipo2.escudo == null ? <img style={{maxHeight: 60, paddingRight: "10px"}} src={LVHPlaceholder}/> : <img style={{maxHeight: 60, paddingRight: "10px"}} src={'https://lvh-images.camila.uy/' + partido.equipo2.escudo}/>}
            <p>{partido.equipo2.nombre}</p>
          </Partido>  
        </TablePartido>
      </CardPartido></ButtonEquipo>
    )); 

    urlStates.setIdDivisionalData(divisional.idDivisional);
  }, [divisional]);

  return (
    <div className="main">
      <DivisionalDesktop>
        <Banner style={{backgroundImage: `url(${Background})`}}>
          <Title>
            <Info>
              <H3Title>{divisional.nombre}</H3Title>
            </Info>
          </Title>
        </Banner>

        <ContainerDivisional>
          <div style={{display: "flex", flexFlow: "column", width: "40%"}}>
            <H3TitleUltPartidos>Tabla de Posiciones</H3TitleUltPartidos>
            <ContainerGrupos> 
              {cardGrupos}
            </ContainerGrupos>
          </div> 
          
          <div style={{display: "flex", flexFlow: "column", width: "60%"}}>
            <H3TitleUltPartidos>Ultimos Partidos</H3TitleUltPartidos>
            <ContainerUltimosPartidos>
              <Col>
                {cardUltimosPartidos}
              </Col>
            </ContainerUltimosPartidos>
          </div>
        </ContainerDivisional>

        <Footer>
          <div style={{width: "350px"}}>
            <img src={`${LVHIcon}`} style={{maxWidth: 200, paddingTop: "2%"}}/>
          </div>
          <Sedes>
            <H3Footer>SEDES</H3Footer>
            <UlSedes>
              <LiSedes><img src={`${Ball}`} style={{maxWidth: 15, paddingRight: "10px"}}/>El Galpón - Paraguay 2211 casi Freire - Uruguay</LiSedes>
              <LiSedes><img src={`${Ball}`} style={{maxWidth: 15, paddingRight: "10px"}}/>Complejo Lokura Fútbol 7 - Camino Sosa Chaferro entre Luis Batlle Berres y Camino Las Flores Paso de la Arena</LiSedes>
              <LiSedes><img src={`${Ball}`} style={{maxWidth: 15, paddingRight: "10px"}}/>Medio Campo - Avenida Dr. Luis Alberto de Herrera 2992</LiSedes>
              <LiSedes><img src={`${Ball}`} style={{maxWidth: 15, paddingRight: "10px"}}/>Stokolmo - Camino Castro 404 bis</LiSedes>
            </UlSedes>
          </Sedes>
          <Contacto>
            <H3Footer>CONTACTO</H3Footer>
            <UlSedes>
              <LiSedes><img src={`${Email}`} style={{maxWidth: 20, paddingRight: "10px"}}/>lvheventos@gmail.com</LiSedes>
              <LiSedes><img src={`${Phone}`} style={{maxWidth: 20, paddingRight: "10px"}}/>+598 98 547 535</LiSedes>
            </UlSedes>
          </Contacto>
        </Footer>
      </DivisionalDesktop>
      
      <DivisionalMobile>
        <Banner style={{backgroundImage: `url(${Background})`}}>
          <Title>
            <Info>
              <H3Title>{divisional.nombre}</H3Title>
            </Info>
          </Title>
        </Banner>

        <ContainerDivisionalMobile>
          <div style={{display: "flex", flexFlow: "column", width: "100%"}}>
            <H3TitleUltPartidos>Tabla de Posiciones</H3TitleUltPartidos>
            <ContainerGruposMobile> 
              {cardGrupos}
            </ContainerGruposMobile>
          </div> 
          
          <div style={{display: "flex", flexFlow: "column", width: "100%"}}>
            <H3TitleUltPartidos>Ultimos Partidos</H3TitleUltPartidos>
            <ContainerUltimosPartidosMobile>
              <Col>
                {cardUltimosPartidos}
              </Col>
            </ContainerUltimosPartidosMobile>
          </div>
        </ContainerDivisionalMobile>

        <Footer style={{paddingTop: "20px"}}>
          <div style={{width: "30%", margin: "0 10px"}}>
            <img src={`${LVHIcon}`} style={{maxWidth: 90, paddingTop: "2%"}}/>
          </div>
          <SedesMobile>
            <H3Footer>SEDES</H3Footer>
            <UlSedes style={{fontSize: "9px"}}>
              <LiSedes style={{marginBottom: "15px"}}><img src={`${Ball}`} style={{maxWidth: 8, paddingRight: "10px"}}/>El Galpón - Paraguay 2211 casi Freire - Uruguay</LiSedes>
              <LiSedes><img src={`${Ball}`} style={{maxWidth: 8, paddingRight: "10px"}}/>Complejo Lokura Fútbol 7 - Camino Sosa Chaferro entre Luis Batlle Berres y Camino Las Flores Paso de la Arena</LiSedes>
              <LiSedes><img src={`${Ball}`} style={{maxWidth: 8, paddingRight: "10px"}}/>Medio Campo - Avenida Dr. Luis Alberto de Herrera 2992</LiSedes>
              <LiSedes><img src={`${Ball}`} style={{maxWidth: 8, paddingRight: "10px"}}/>Stokolmo - Camino Castro 404 bis</LiSedes>
            </UlSedes>
          </SedesMobile>
          <ContactoMobile>
            <H3Footer>CONTACTO</H3Footer>
            <UlSedes style={{fontSize: "8px"}}>
              <LiSedes><img src={`${Email}`} style={{maxWidth: 10, paddingRight: "10px"}}/>lvheventos@gmail.com</LiSedes>
              <LiSedes><img src={`${Phone}`} style={{maxWidth: 10, paddingRight: "10px"}}/>+598 98 547 535</LiSedes>
            </UlSedes>
          </ContactoMobile>
        </Footer>
      </DivisionalMobile>
    </div>
  );
}

export default Divisional;

export async function loader({params}) {
  const axios = require('axios');
  let divisional = null;
  const config = {
      method: 'get',
      url: 'https://lvh.camila.uy/divisional/' + params.divisional + '/equipos',
      headers: {
        'Accept': 'application/json'
      }
  };

  await axios(config)
    .then(function (response) {
      divisional = response.data;
    })

  return divisional;
}